interface OrdersData {
  totalOrders: number;
  monthlyOrders: number;
  weeklyOrders: number;
  dailyOrders: number;
}

interface OrdersCardProps {
  ordersData: OrdersData;
}

const OrdersCard: React.FC<OrdersCardProps> = ({ ordersData }) => {
  return (
    <div className="rounded-sm border border-stroke bg-white py-6 px-7.5 shadow-default dark:border-strokedark dark:bg-boxdark hover:shadow-lg transition-shadow duration-200 cursor-pointer">
      <div className="mx-2">
        <div>
          <span className="text-sm font-medium">Orders Overview</span>
        </div>
        
        <div className="mt-3 grid grid-cols-2 gap-2">
          <div className="text-left">
            <h5 className="text-sm font-semibold text-blue-600 dark:text-blue-400">
              {ordersData.monthlyOrders}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Monthly
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-green-600 dark:text-green-400">
              {ordersData.weeklyOrders}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Weekly
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-purple-600 dark:text-purple-400">
              {ordersData.dailyOrders}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              Daily
            </span>
          </div>
          
          <div className="text-left">
            <h5 className="text-sm font-semibold text-orange-600 dark:text-orange-400">
              {ordersData.totalOrders}
            </h5>
            <span className="text-xs text-gray-600 dark:text-gray-400">
              All Time
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrdersCard;